<template>
    <v-container class="pt-6">
      <v-card class="pa-6" outlined style="max-width: 800px; margin: auto;">
        <!-- Encabezado -->
        <v-btn @click="$router.go(-1)" text class="pl-0">
          <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
          <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
        </v-btn>
        <div class="d-flex justify-space-between align-center mb-6">
          <div>
            <div style="font-size: 20px; font-family: 'montserrat-bold';">Factura #{{ factura.external_invoice_id }}</div>
            <v-chip class="mt-2" color="blue" dark small label style="text-transform: capitalize;">
              {{ factura.estatus }}
            </v-chip>
          </div>
        </div>

        <v-divider></v-divider>

        <div class="mb-3 mt-3" style="font-family: 'montserrat-bold'; font-size: 16px;">
          Detalle de la factura
        </div>
        <!-- Cedente y Deudor -->
        <v-row class="my-4">
          <v-col cols="6">
            <strong>PO:</strong>
            <div>{{ factura.external_invoice_id }}</div>
          </v-col>
          <v-col cols="6">
            <strong>Referencia:</strong>
            <div>{{ factura.reference }}</div>
          </v-col>
        </v-row>
        <v-row class="my-4">
          <v-col cols="6">
            <strong>Cedente:</strong>
            <div>{{ factura.cedente_name }}</div>
          </v-col>
          <v-col cols="6">
            <strong>Deudor:</strong>
            <div>{{ factura.deudor_name }}</div>
          </v-col>
        </v-row>
        <v-row class="my-4">
          <v-col cols="6">
            <strong>Monto:</strong>
            <div>${{ formatMoney(factura.monto_total) }} USD</div>
          </v-col>
          <v-col cols="6" v-if="factura.ajuste > 0">
            <strong>Ajuste:</strong>
            <div>${{ formatMoney(factura.ajuste) }} USD</div>
          </v-col>
        </v-row>
        <!-- Fechas adicionales -->
        <v-row class="my-4">
          <v-col cols="6">
            <strong>Fecha de emisión:</strong>
            <div>{{ formatDate(factura.fecha_emision) }}</div>
          </v-col>
          <v-col cols="6">
            <strong>Fecha de vencimiento:</strong>
            <div>{{ formatDate(factura.fecha_vencimiento) }}</div>
          </v-col>
        </v-row>
        <v-row class="my-4">
          <v-col cols="6">
            <strong>Fecha de validacion:</strong>
            <div>{{ formatDate(factura.fechaValidacion) || '—' }}</div>
          </v-col>
          <v-col cols="6">
            <strong>Fecha de aprobacion:</strong>
            <div>{{ formatDate(factura.fechaAprobacion) || '—' }}</div>
          </v-col>
        </v-row>

        <!-- Resumen financiero -->
        <!-- <v-divider class="my-4"></v-divider>
        <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 16px;">Resumen financiero</div>

        <div class="mb-4" style="background-color: #f1f6fb; padding: 16px; border-radius: 12px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);">
          <div style="font-family: 'montserrat-bold'; font-size: 14px;">
            Total de la factura: <strong>${{ formatMoney(factura.monto_total) }} USD</strong>
          </div>

          <v-divider class="my-3" />

          <div style="font-family: 'montserrat-medium'; font-size: 14px;">
            Pago del deudor:
            <strong style="color: green;">+${{ formatMoney(factura.pagosDeudor?.[0]?.amount || 0) }} USD</strong>
          </div>

          <div style="font-family: 'montserrat-medium'; font-size: 14px;">
            Adelanto:
            <strong>-${{ formatMoney(factura.adelantos?.[0]?.amount || 0) }} USD</strong>
          </div>

          <div style="font-family: 'montserrat-medium'; font-size: 14px;">
            Interés moratorio:
            <strong>
              -${{
                (factura.dias_moratorios > 0
                  ? (factura.monto_total * (factura.dias_moratorios / 30 * 0.025)).toFixed(2)
                  : "0.00")
              }} USD ({{ Math.max(0, factura.dias_moratorios || 0) }} días)
            </strong>
          </div>

          <div style="font-family: 'montserrat-medium'; font-size: 14px;">
            Comisión (2.5%): <strong>-${{ formatMoney((factura.monto_total || 0) * 0.025) }} USD</strong>
          </div>

          <v-divider class="my-3" />

          <div style="font-family: 'montserrat-bold'; font-size: 16px;">
            Monto sugerido a liquidar: <strong>${{ formatMoney(montoSugerido) }} USD</strong>
          </div>
          <div style="font-family: 'montserrat-bold'; font-size: 16px; margin-top: 4px;">
            Monto liquidado: 
            <strong style="color: #0075B8;">
              ${{ formatMoney(factura.liquidaciones?.[0]?.amount || 0) }} USD
            </strong>
          </div>

          <div
            :style="{
              fontFamily: 'montserrat-bold',
              fontSize: '14px',
              marginTop: '4px',
              color: Math.abs((factura.liquidaciones?.[0]?.amount || 0) - montoSugerido) < 0.01 ? 'green' : 'red'
            }"
          >
            Diferencia:
            <strong>
              ${{ formatMoney(((factura.liquidaciones?.[0]?.amount || 0) - montoSugerido)) }} USD
            </strong>
          </div>
          <v-divider class="my-3" />


          <div v-if="diferenciaFinal < 0 && totalCompensado > 0" style="margin-top: 12px;">
            <div style="font-family: 'montserrat-bold'; font-size: 14px;">Detalle de compensación</div>

            <div style="font-family: 'montserrat-medium'; font-size: 14px;">
              A deber:
              <strong style="color: red;">
                ${{ formatMoney(diferenciaFinal) }} USD
              </strong>
            </div>

            <div style="font-family: 'montserrat-medium'; font-size: 14px;">
              Compensado:
              <strong style="color: #0075B8;">
                ${{ formatMoney(totalCompensado) }} USD
              </strong>
            </div>

            <div style="font-family: 'montserrat-medium'; font-size: 14px;">
              Diferencia:
              <strong :style="{ color: Math.abs(diferenciaFinal + totalCompensado) < 0.01 ? 'green' : 'red' }">
                ${{ formatMoney(diferenciaFinal + totalCompensado) }} USD
              </strong>
            </div>
          </div>
        </div> -->

        <!-- Documentos -->
        <v-divider class="my-4"></v-divider>
        <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 16px;">Documentos adjuntos</div>
        <v-row dense>
          <v-col v-for="(doc, index) in factura.documentos || []" :key="index" cols="12" sm="6" md="4">
            <v-card class="pa-3 d-flex align-center justify-space-between" outlined>
              <div class="d-flex flex-column">
                <span style="font-weight: 600;">{{ doc.file_name }}</span>
                <span class="text--secondary text-caption">
                  {{ doc.size ? (doc.size / 1024).toFixed(1) + ' KB' : 'Documento subido' }}
                </span>
              </div>
              <v-btn icon @click="abrirDocumento(doc)" target="_blank">
                <v-icon color="primary">mdi-eye</v-icon>
              </v-btn>
            </v-card>
          </v-col>
          <v-col v-if="!factura.documentos || !factura.documentos.length">
            <div class="grey--text">No hay documentos adjuntos</div>
          </v-col>
        </v-row>

        <!-- Adelantos -->
        <v-divider class="my-4"></v-divider>
        <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 16px;">Adelantos realizados</div>
        <v-list dense>
          <v-list-item v-for="adelanto in factura.adelantos || []" :key="adelanto.id">
            <v-list-item-content>
              <v-list-item-title>
                {{ formatDate(adelanto.date_paid) }} - ${{ formatMoney(adelanto.amount) }} USD - Origen: {{ adelanto.origin }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="adelanto.file_url">
                <a @click="abrirComprobante(adelanto.file_url)" target="_blank" style="color: #0075B8;">Ver comprobante</a>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-row dense>
            <v-col v-if="factura?.adelantos?.length === 0">
              <div class="grey--text">No hay adelantos realizados</div>
            </v-col>
          </v-row>
        </v-list>

        <!-- Pagos del deudor -->
        <v-divider class="my-4"></v-divider>
        <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 16px;">Pagos del deudor</div>
        <v-list dense>
          <v-list-item v-for="pago in factura.pagosDeudor || []" :key="pago.id">
            <v-list-item-content>
              <v-list-item-title>
                {{ formatDate(pago.date_paid) }} - ${{ formatMoney(pago.amount) }} USD - Origen: {{ pago.origin }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="pago.file_url">
                <a @click="abrirComprobante(pago.file_url)" target="_blank" style="color: #0075B8;">Ver comprobante</a>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-row dense>
            <v-col v-if="factura?.pagosDeudor?.length === 0">
              <div class="grey--text">No hay cobros realizados</div>
            </v-col>
          </v-row>
        </v-list>

        <!-- Liquidaciones -->
        <v-divider class="my-4"></v-divider>
        <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 16px;">Liquidaciones al cedente</div>
        <v-list dense>
          <v-list-item v-for="liq in factura.liquidaciones || []" :key="liq.id">
            <v-list-item-content>
              <v-list-item-title>
                {{ formatDate(liq.date_paid) }} - ${{ formatMoney(liq.amount) }} USD - Destino: {{ liq.destination }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="liq.file_url">
                <a @click="abrirComprobante(liq.file_url)" target="_blank" style="color: #0075B8;">Ver comprobante</a>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-row dense>
            <v-col v-if="factura?.liquidaciones?.length === 0">
              <div class="grey--text">No hay liquidaciones realizadas</div>
            </v-col>
          </v-row>
        </v-list>

      </v-card>
    </v-container>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      factura: {
        id: 104,
        cliente: 'Logística Fénix',
        estado: 'PENDIENTE_APROBACION',
        fechaCarga: '2025-06-10',
        fechaAprobacion: null,
        fechaLiquidacion: null,
        monto: 98000,
        montoPagado: null
      },
      dialogAprobar: false,
      dialogLiquidar: false,
      metodoLiquidacion: null,
      fechaDeposito: null,
      menuFecha: false,
    };
  },
  computed: {
    etiquetaEstado() {
      switch (this.factura.estado) {
        case 'PENDIENTE_APROBACION': return 'Pendiente de aprobación';
        case 'PENDIENTE_LIQUIDACION': return 'Pendiente de liquidar';
        case 'LIQUIDADA': return 'Liquidada';
        default: return this.factura.estado;
      }
    },
    puedeLiquidar() {
      return this.metodoLiquidacion === 'Fresher Account' || (this.metodoLiquidacion === 'Otro' && this.fechaDeposito);
    },
    montoSugerido() {
      const pagoDeudor = +((+this.factura.pagosDeudor?.[0]?.amount || 0).toFixed(2));
      const adelanto = +((+this.factura.adelantos?.[0]?.amount || 0).toFixed(2));
      const interesMoratorio = +(
        this.factura.dias_moratorios > 0
          ? (this.factura.monto_total * (this.factura.dias_moratorios / 30 * 0.025)).toFixed(2)
          : "0.00"
      );
      const interes = +(((+this.factura.monto_total || 0) * 0.025).toFixed(2));

      const resultado = pagoDeudor - adelanto - interes - interesMoratorio;

      return +resultado.toFixed(2);
    },
    montoLiquidadoTotal() {
      const liquidado = this.factura.liquidaciones?.reduce((acc, l) => acc + Number(l.amount || 0), 0);
      const compensado = this.factura.compensaciones?.reduce((acc, c) => acc + Number(c.amount_applied || 0), 0);
      return liquidado + compensado;
    },
    diferenciaFinal() {
      const liquidado = this.factura.liquidaciones?.reduce((acc, l) => acc + Number(l.amount || 0), 0);
      return this.montoSugerido - liquidado;
    },
    totalCompensado() {
      return this.factura.compensaciones?.reduce((acc, c) => acc + Number(c.amount_applied || 0), 0);
    }
  },
  methods: {
    async getDetailInvoice() {
      try {
        this.isLoading = true;
        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/client/detail/${this.$route.params.invoiceId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.factura = response.data.invoice;
        this.factura.compensaciones = response.data.compensaciones || [];
        this.factura.statusHistory = response.data.statusHistory || [];
        this.factura.documentos = response.data.documentos || [];
        this.factura.liquidaciones = response.data.liquidaciones || [];
        this.factura.adelantos = response.data.adelantos || [];
        this.factura.pagosDeudor = response.data.pagosDeudor || [];

        // 👉 Calcular días moratorios
        const fechaVencimiento = moment(this.factura.fecha_vencimiento);

        const cobroStatus = this.factura.statusHistory?.find(s => s.status === 'cobrada');

        if (cobroStatus?.changed_at) {
          const fechaCobro = moment(cobroStatus.changed_at);
          const diasMoratorios = fechaCobro.diff(fechaVencimiento, 'days');
          this.factura.dias_moratorios = diasMoratorios > 0 ? diasMoratorios : 0;
        } else {
          this.factura.dias_moratorios = 0;
        }

        this.mixSuccess(response.data.message || 'Factura mostrada correctamente');
        this.dialogValidateInvoice = false;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    aprobarFactura() {
      this.factura.estado = 'PENDIENTE_LIQUIDACION';
      this.factura.fechaAprobacion = moment().format('YYYY-MM-DD');
      this.dialogAprobar = false;
    },
    confirmarLiquidacion() {
      const fecha = this.metodoLiquidacion === 'Fresher Account'
        ? moment().format('YYYY-MM-DD')
        : this.fechaDeposito;

      this.factura.fechaLiquidacion = fecha;
      this.factura.montoPagado = this.factura.monto;
      this.factura.estado = 'LIQUIDADA';

      // Reset
      this.dialogLiquidar = false;
      this.metodoLiquidacion = null;
      this.fechaDeposito = null;
    },
    verTerminos() {
      // Aquí iría la lógica para mostrar los términos y condiciones
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    abrirDocumento(doc) {
      window.open(`${doc.file_url}`, '_blank');
    },
    abrirComprobante(doc) {
      window.open(doc, '_blank');
    }
  },
  beforeMount() {
    this.getDetailInvoice();
  }
};
</script>
